'use strict';

import CookieUtil from 'standard-vote/app/scripts/util/cookie.js';

module.exports = CookieUtil;



// WEBPACK FOOTER //
// ./app/scripts/util/cookie.js